const data: any = {
  func: {
    mainTitle: "",
    subTitle: "",
    desc: "",
    backImageUrl: "//jdc.jd.com/img/1440x100?fs=20&t=1440*100PX",
    layoutType: "v",
    vInterval: '["36px","8px","64px"]',
    hInterval: '["60px"]',
    link: [{ text: "", link: "", styleType: "" }],
    searchBar: {
      phText: "搜索主题或关键词",
      icon: "https://img13.360buyimg.com/imagetools/jfs/t1/112729/7/10511/664/5eec4c11E49565c2d/09d061556d84c026.png",
      keywords: [
        {
          text: "用户API",
          link: "/apilistnewdetail.html?first=502&second=505",
        },
        {
          text: "商品API",
          link: "/apilistnewdetail.html?first=440&second=442",
        },
        {
          text: "咚咚API",
          link: "/apilistnewdetail.html?first=335&second=336",
        },
        { text: "权限申请", link: "/commondoc.html?listId=170" },
        { text: "API调用", link: "/commondoc.html?listId=33" },
        { text: "SDK使用", link: "/commondoc.html?listId=167" },
        { text: "网关错误码", link: "/commondoc.html?listId=171" },
        { text: "获取授权", link: "/commondoc.html?listId=32" },
      ],
      redirectUrl: "",
    },
  },
  style: {
    mainColor: "rgba(34,127,255,1)",
    minHeight: "100px",
    maxWidth: "956px",
    padding: "20px 0 12px",
    arrFontSize: [{ mainTitle: "", subTitle: "", desc: "" }],
  },
  data: {},
  _clstag_: "jdzeus_apilist_zeus_document_support_banner",
};
export default data;
